import { useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import BookAuthorsDetails from 'src/components/BookAuthorsDetails/BookAuthorsDetails';
import { contentType } from 'src/Helpers/constant';
const btnstyle = {
  color: 'white',
  backgroundColor: 'black',
  border: '2px solid black',
  borderRadius: '5px',
  padding: '5px',
  position: 'fixed',
  top: '50%',
  left: '20px',
};
export const AuthorReaderRender = ({
  content,
  idx,
  menuType,
  editBtn,
  renderType,
  handleUpdate,
  getChapterContentCall,
  isHeader = false,
}) => {
  const ref = useRef();

  let innerContent;
  if (menuType === 'CUSTOM' && isHeader) {
    innerContent = content?.custom_content;
  } else {
    innerContent = menuType === contentType.regular ? content?.regular_content : content?.express_content;
  }

  let authorArray = [];
  let instructorArray = [];
  if (menuType === 'EXPRESS' && content.express_authors) {
    authorArray.push(content.express_authors);
  } else if (menuType === 'REGULAR' && content.regular_authors) {
    authorArray.push(content.regular_authors);
  }
  if (authorArray.length === 0 && content?.authors?.length > 0) {
    authorArray = content.authors;
  }
  if (content?.instructors?.length > 0) {
    instructorArray = content.instructors;
  }

  return (
    <div>
      <div className="w-75 m-auto">
        {authorArray?.length > 0 || instructorArray?.length > 0 ? (
          <div className="d-flex align-items-center justify-content-between">
            {authorArray?.length > 0 && <BookAuthorsDetails authorArrays={authorArray} />}
            {instructorArray?.length > 0 && <BookAuthorsDetails authorArrays={instructorArray} isEdit={true} />}
          </div>
        ) : (
          ''
        )}
        <>
          <div
            ref={ref}
            id={content._id}
            key={idx}
            className="bookContent py-3"
            dangerouslySetInnerHTML={{
              __html: innerContent,
            }}
          ></div>
        </>
      </div>
    </div>
  );
};
export const InstructorRender = ({ content, idx, menuType, editBtn, handleUpdate, getChapterContentCall }) => {
  let innerContent;
  let authorArray = [];
  let instructorArray = [];

  if (menuType === 'EXPRESS' && content.express_authors) {
    authorArray.push(content.express_authors);
  } else if (menuType === 'REGULAR' && content.regular_authors) {
    authorArray.push(content.regular_authors);
  }
  if (authorArray.length === 0 && content?.authors?.length > 0) {
    authorArray = content.authors;
  }
  if (content?.instructors?.length > 0) {
    instructorArray = content.instructors;
  }
  if (menuType === 'CUSTOM') {
    if (content.permissions?.bookType == 'clone') {
      innerContent = content?.custom_content;
    } else {
      innerContent = content?.header_content;
    }
  } else {
    innerContent = menuType === contentType.regular ? content?.regular_content : content?.express_content;
  }

  const [updatedContent, setNewContent] = useState('empty');

  const hideButton = (id) => (document.getElementById(`${id}-button`).className = 'd-none');
  if (menuType !== 'CUSTOM') {
    return (
      <>
        <div
          id={content._id}
          key={idx}
          dangerouslySetInnerHTML={{
            __html: innerContent,
          }}
          className="bookContent py-3"
        ></div>
      </>
    );
  } else {
    return (
      <div>
        <div className="w-75 m-auto">
          {authorArray?.length > 0 || instructorArray?.length > 0 ? (
            <div className="d-flex align-items-center justify-content-between">
              {authorArray?.length > 0 && <BookAuthorsDetails authorArrays={authorArray} />}
              {instructorArray?.length > 0 && <BookAuthorsDetails authorArrays={instructorArray} isEdit={true} />}
            </div>
          ) : (
            ''
          )}
          <>
            <div id={content._id} key={idx}>
              <div
                id={`bookContent-${content._id}`}
                className="bookContent py-3"
                dangerouslySetInnerHTML={{
                  __html: innerContent,
                }}
              ></div>
            </div>
          </>
        </div>
        <Button
          id={`${content._id}-button`}
          className="d-none"
          variant="outline-success"
          size="sm"
          // onClick={() => handleUpdate(ref.current, content)}
          onClick={() => {
            if (updatedContent !== 'empty') {
              console.log('....f', updatedContent);
              const data = { ...content, updateCon: updatedContent };
              handleUpdate(data);
            } else {
              handleUpdate(content);
            }
            document.getElementById(content._id).style.display = 'block';
            document.getElementsByClassName('ck-editor')[0].style.display = 'none';
            getChapterContentCall();
            setNewContent('empty');
            hideButton(content._id);
          }}
          style={btnstyle}
        >
          Save
        </Button>
      </div>
    );
  }
};
export const StudentRender = ({ htmlType, content, key }) => {
  let innerContent;
  let authorArray = [],
    instructorArray = [];
  if (htmlType === 'EXPRESS' && content.express_authors) {
    authorArray.push(content.express_authors);
  } else if (htmlType === 'REGULAR' && content.regular_authors) {
    authorArray.push(content.regular_authors);
  }
  if (authorArray.length === 0 && content?.authors?.length > 0) {
    authorArray = content.authors;
  }
  if (content?.instructors?.length > 0) {
    instructorArray = content.instructors;
  }
  if (htmlType === 'CUSTOM') {
    if (content.permissions?.bookType == 'clone') {
      innerContent = content?.custom_content;
    }
  } else {
    innerContent = htmlType === contentType.regular ? content?.regular_content : content?.express_content;
  }

  return (
    <div className="w-75 m-auto">
      {authorArray?.length > 0 || instructorArray?.length > 0 ? (
        <div className="d-flex align-items-center justify-content-between">
          {authorArray?.length > 0 && <BookAuthorsDetails authorArrays={authorArray} />}
          {instructorArray?.length > 0 && <BookAuthorsDetails authorArrays={instructorArray} isEdit={true} />}
        </div>
      ) : (
        ''
      )}
      <div
        id="chapter-list"
        key={key}
        dangerouslySetInnerHTML={{
          __html: innerContent,
        }}
        className="bookContent"
      ></div>
    </div>
  );
};
export const StudentHeaderRender = ({ htmlType, content, key }) => {
  let innerContent;
  let authorArray = [];
  let instructorArray = [];
  if (htmlType === 'EXPRESS' && content.express_authors) {
    authorArray.push(content.express_authors);
  } else if (htmlType === 'REGULAR' && content.regular_authors) {
    authorArray.push(content.regular_authors);
  }
  if (authorArray.length === 0 && content?.authors?.length > 0) {
    authorArray = content.authors;
  }
  console.log({ authorArray, content });
  if (htmlType === 'CUSTOM') {
    innerContent = content?.custom_content;
    if (content?.instructors?.length > 0) {
      instructorArray = content.instructors;
    }
  } else {
    innerContent = htmlType === contentType.regular ? content?.regular_content : content?.express_content;
  }

  return (
    <div className="w-75 m-auto">
      {authorArray?.length > 0 || instructorArray?.length > 0 ? (
        <div className="d-flex align-items-center justify-content-between">
          {authorArray?.length > 0 && <BookAuthorsDetails authorArrays={authorArray} />}
          {instructorArray?.length > 0 && <BookAuthorsDetails authorArrays={instructorArray} isEdit={true} />}
        </div>
      ) : (
        ''
      )}

      <div
        id="chapter-list"
        key={key}
        dangerouslySetInnerHTML={{
          __html: innerContent,
        }}
        className="bookContent"
      ></div>
    </div>
  );
};
